var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoContentsFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B6BFCE",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 22c-2.757 0-5-2.243-5-5v-7a.666.666 0 1 1 1.333 0v7A3.67 3.67 0 0 0 14 20.667 3.67 3.67 0 0 0 17.667 17V9.667a2.336 2.336 0 0 0-2.334-2.334A2.336 2.336 0 0 0 13 9.667v6.666a1.001 1.001 0 0 0 2 0V10a.666.666 0 1 1 1.333 0v6.333A2.336 2.336 0 0 1 14 18.667a2.336 2.336 0 0 1-2.333-2.334V9.667A3.671 3.671 0 0 1 15.333 6 3.671 3.671 0 0 1 19 9.667V17c0 2.757-2.243 5-5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 22c-2.757 0-5-2.243-5-5v-7a.666.666 0 1 1 1.333 0v7A3.67 3.67 0 0 0 14 20.667 3.67 3.67 0 0 0 17.667 17V9.667a2.336 2.336 0 0 0-2.334-2.334A2.336 2.336 0 0 0 13 9.667v6.666a1.001 1.001 0 0 0 2 0V10a.666.666 0 1 1 1.333 0v6.333A2.336 2.336 0 0 1 14 18.667a2.336 2.336 0 0 1-2.333-2.334V9.667A3.671 3.671 0 0 1 15.333 6 3.671 3.671 0 0 1 19 9.667V17c0 2.757-2.243 5-5 5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoContentsFile);
export default __webpack_public_path__ + "static/media/ico-contents-file.1f697151ef2ff38b096c08136ab5b60b.svg";
export { ForwardRef as ReactComponent };